core-icon-button {
  display: flex;
}

.core-icon-button {
  --border-width: 1px;
  --outline-width: 2px;
  --outline-offset: 2px;
  display: flex;
  align-items: center;
  border-style: none;
  cursor: pointer;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
  color var(--motion-duration-fast) var(--motion-easing-move),
  border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-icon-button core-icon {
  display: flex;
}

.core-icon-button:disabled {
  cursor: not-allowed;
}

/* variant classes */
/* Disabled button should not have borders */
.core-icon-button--primary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-primary-border-default);
  background-color: var(--color-action-primary-background-default);
  color: var(--color-action-primary-content-default);
}

.core-icon-button--primary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-primary-border-interacting);
  background-color: var(--color-action-primary-background-interacting);
  color: var(--color-action-primary-content-interacting);
}

.core-icon-button--primary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-primary-border-interacting);
  background-color: var(--color-action-primary-background-interacting);
  color: var(--color-action-primary-content-interacting);
}

.core-icon-button--secondary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-secondary-border-default);
  background-color: var(--color-action-secondary-background-default);
  color: var(--color-action-secondary-content-default);
}

.core-icon-button--secondary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-secondary-border-interacting);
  background-color: var(--color-action-secondary-background-interacting);
  color: var(--color-action-secondary-content-interacting);
}

.core-icon-button--secondary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-secondary-border-interacting);
  background-color: var(--color-action-secondary-background-interacting);
  color: var(--color-action-secondary-content-interacting);
}

.core-icon-button--tertiary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-tertiary-border-default);
  background-color: var(--color-action-tertiary-background-default);
  color: var(--color-action-tertiary-content-default);
}

.core-icon-button--tertiary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-tertiary-border-interacting);
  background-color: var(--color-action-tertiary-background-interacting);
  color: var(--color-action-tertiary-content-interacting);
}

.core-icon-button--tertiary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-tertiary-border-interacting);
  background-color: var(--color-action-tertiary-background-interacting);
  color: var(--color-action-tertiary-content-interacting);
}

.core-icon-button--quaternary:not(:disabled) {
  background-color: transparent;
  color: var(--color-neutral-content-medium);
}

.core-icon-button--quaternary:not(:disabled):hover {
  background-color: var(--color-neutral-background-soft);
}

.core-icon-button--quaternary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  background-color: var(--color-neutral-background-soft);
}

/* size classes */
/* As the height should not be fixed the use of box-sizing property is not possible */
/* Instead the border size is removed from the padding */
.core-icon-button--small:not(.core-icon-button--quaternary):not(:disabled) {
  border-radius: var(--number-radius-small);
  padding: calc(var(--number-spacing-3xsmall) - var(--border-width));
}

.core-icon-button--small.core-icon-button--quaternary {
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-3xsmall);
}

.core-icon-button--medium:not(.core-icon-button--quaternary):not(:disabled) {
  border-radius: var(--number-radius-medium);
  padding: calc(var(--number-spacing-xsmall) - var(--border-width));
}

.core-icon-button--medium.core-icon-button--quaternary {
  border-radius: var(--number-radius-medium);
  padding: var(--number-spacing-xsmall);
}

.core-icon-button--large:not(.core-icon-button--quaternary):not(:disabled) {
  border-radius: var(--number-radius-large);
  padding: calc(var(--number-spacing-small) - var(--border-width));
}

.core-icon-button--large.core-icon-button--quaternary {
  border-radius: var(--number-radius-large);
  padding: var(--number-spacing-small);
}

.core-icon-button--primary:disabled, .core-icon-button--secondary:disabled {
  background-color: var(--color-global-all-disabled-soft);
  color: var(--color-global-all-disabled-strong);
}

.core-icon-button--primary:disabled, .core-icon-button--secondary:disabled, .core-icon-button--tertiary:disabled {
  border: 0;
}

.core-icon-button--tertiary:disabled, .core-icon-button--quaternary:disabled  {
  background-color: transparent;
  color: var(--color-global-all-disabled-strong);
}

.core-icon-button--small.core-icon-button--primary:disabled, .core-icon-button--small.core-icon-button--secondary:disabled, .core-icon-button--small.core-icon-button--tertiary:disabled {
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-3xsmall);
}

.core-icon-button--medium.core-icon-button--primary:disabled, .core-icon-button--medium.core-icon-button--secondary:disabled, .core-icon-button--medium.core-icon-button--tertiary:disabled  {
  border-radius: var(--number-radius-medium);
  padding: var(--number-spacing-xsmall);
}

.core-icon-button--large.core-icon-button--primary:disabled, .core-icon-button--large.core-icon-button--secondary:disabled, .core-icon-button--large.core-icon-button--tertiary:disabled {
  border-radius: var(--number-radius-large);
  padding: var(--number-spacing-small);
}
